/**
 * Shared subscription status constants: used by both frontend and backend.
 */

export const SUBSCRIPTION_STATUS = {
    NO_ACCESS: "no_access",
    PENDING: "pending",
    ACTIVE: "active",
    EXPIRED: "expired",
} as const;

export type SubscriptionStatus =
    (typeof SUBSCRIPTION_STATUS)[keyof typeof SUBSCRIPTION_STATUS];

/**
 * What each status is called on screen.
 *
 * `pending` reads "Pending invitation" rather than a bare "Pending": pending
 * alone says that something is waiting without saying what. The invitation is
 * what the admin sent and what the reminders follow (#588: the PO's word,
 * which replaced "Invitation sent").
 *
 * `no_access` reads "Not invited" (#639): "No access" gave the consequence and
 * left the PO asking why. The cause is what tells the admin what to do: send
 * the invitation. It is not "inactive": that would read as deactivated, or as
 * a user who stopped signing in.
 *
 * Read only by `StatusChip` on the frontend. The backend imports the values
 * above, never these labels, so this map is wording, with no API or database
 * meaning.
 */
export const SUBSCRIPTION_STATUS_LABELS: Record<SubscriptionStatus, string> = {
    no_access: "Not invited",
    pending: "Pending invitation",
    active: "Active",
    expired: "Expired",
};
